import apiUrl from '../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
// import VueAlertify from 'vue-alertify';
import Loader from './../../shared/loader'
import { BasicSelect } from 'vue-search-select'

export default{
    name:'newunicommerceproduct',
    components:{
      Loader,
      BasicSelect,
    },
    props:[],
    data() {
        return {
          text: '',
          isValid: false,
          skuStringArray:[],
          skuInputString:'',
          client:'',
          clientid:'',
          createdbyEmail: '',
          isLoading:false,
          createdResponseArray:[],
          updatedResponseArray:[],
          failedResponseArray:[],
          success_seen:false,
          update_seen:false,
          failure_seen:false,
          downloadCreatedButton:false,
          downloadUpdatedButton:false,
          downloadFailedButton:false,
          success_message:'',
          update_message:'',
          failure_message:'',
          downloadButtonDisplay:false
        };
      },

    computed: {},
    mounted() {
      var userdetailEncrypt = window.localStorage.getItem('userdetail')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      this.user_type = userdetail.utype;
      this.client = window.localStorage.getItem('selectedClient')
      this.clientid =this.client
      this.checkclient()
      switch (this.user_type) {
        case 'system_user':
            this.createdbyEmail = userdetail.email;
            this.checkclient()
            break;

        case 'client_user':
            this.createdbyEmail = userdetail.email;
            break;

        case 'warehouse_user':
            this.createdbyEmail = userdetail.email;
            this.checkclient()
            break;

        default:
            this.$alertify.error("Unauthorised user, Please contact your system admin");
            break
    }
    },
    methods : {
        validateInput(event) {
            const regex = /^[#_\/\-\w\n,]*$/;
            this.isValid = regex.test(this.text);
            if (this.isValid) {
              this.skuInputString=event.target.value;
              this.downloadButtonDisplay=true;
              if(this.skuInputString==''){
                this.isValid=false;
                this.downloadButtonDisplay=false;
              }
            } else {
              this.$alertify.error(this.$t('unicommerce.importUniwareProduct.invalidInput'))
              this.isValid=false;
              this.downloadButtonDisplay=false;
            }
          },
          checkclient(){
            if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") == '')
            {
              this.$alertify.error(this.$t('common.clientError'))
              this.isLoading = false
              return false
            }
          },
          convertSkuStringToArray(){
            if(this.skuInputString==''){
              this.skuStringArray=[];
              return 
            }
            if(this.skuInputString.includes(',')){
              this.skuStringArray=this.skuInputString.split(',').map(item => item.trim()).filter(item => item !== '');
            }else{
              this.skuStringArray=this.skuInputString.split('\n').map(item => item.trim()).filter(item => item !== '');
            }
          },
          onChangeHandler(event) {
            this.validateInput(event);
          },
        showunicommerceproduct(){
            this.$emit("goBackToParent")
        },
        async uploadProductSync() {
          this.convertSkuStringToArray();
          if(this.skuStringArray.length>50){
            this.$alertify.error("Maximum SKU's allowed is 50");
              this.isValid=false;
              this.downloadButtonDisplay=false;
              return false;
          }
          const uniqueItems = new Set(this.skuStringArray);
            if (uniqueItems.size !== this.skuStringArray.length) {
              this.$alertify.error("Duplicate product not allowed.");
              this.isValid=false;
              this.downloadButtonDisplay=false;
              return false;
            }
          var userToken = window.localStorage.getItem('userToken');
          var myStr = userToken.replace(/"/g, '');
          this.isLoading = true;
          this.input = {
              'clientid': this.clientid,
              'skustring': this.skuStringArray,
              'createdby': this.createdbyEmail,
              'merchantid': 1
          };
      
          try {
              const response = await axios({
                  method: 'POST',
                  url: apiUrl.api_url + 'importUniwareProduct',
                  data: this.input,
                  headers: {
                      'Authorization': 'Bearer ' + myStr
                  }
              });
    
              if (response.data.data.responsecode === 200 && response.data.data.status === true) {
                  this.isLoading = false;
                  this.$alertify.success(response.data.data.msg);
                  this.text='';
                  this.isValid=false;
                  this.success_seen=false;
                  this.update_seen=false;
                  this.failure_seen=false;
                  this.downloadCreatedButton=false;
                  this.downloadUpdatedButton=false;
                  this.downloadFailedButton=false;
      
                  if (response.data.data.data.created && response.data.data.data.created.length > 0) {
                      this.success_seen = true;
                      this.downloadCreatedButton = true;
                      this.createdResponseArray = response.data.data.data.created;
                      this.success_message = response.data.data.data.created.length + ' ' + this.$t('unicommerce.importUniwareProduct.productCreationMessage');
                  }
                  if (response.data.data.data.updated && response.data.data.data.updated.length > 0) {
                      this.update_seen = true;
                      this.downloadUpdatedButton = true;
                      this.updatedResponseArray = response.data.data.data.updated;
                      this.update_message = response.data.data.data.updated.length + ' ' + this.$t('unicommerce.importUniwareProduct.productUpdationMessage');
                  }
                  if (response.data.data.data.failed && response.data.data.data.failed.length > 0) {
                      this.failure_seen = true;
                      this.downloadFailedButton = true;
                      this.failedResponseArray = response.data.data.data.failed;
                      this.failure_message = response.data.data.data.failed.length + ' ' + this.$t('unicommerce.importUniwareProduct.productFailedMessage');
                  }
              } else {
                  this.isLoading = false;
                  this.$alertify.error(response.data.data.msg);
              }
          } catch (httpException) {
              console.error('Exception is:', httpException);
          }
      },
        arrayToCSV(array) {
          if (!array.length) return '';
    
          const headers = Object.keys(array[0]).join(','); 
          const rows = array.map(obj => Object.values(obj).join(',')); 
    
          return [headers, ...rows].join('\n');
        },

        arrayToCSVFailed(array){
          if (!array.length) return '';

          const headers = Object.keys(array[0]).map(key=>key==='msg'?'Error':key).join(',');
          const rows = array.map(obj => {
            return `${obj.clientproductid},${obj.status},${obj.status ? '' : 'Some fields are required and cannot be empty - (MRP(INR)*)'}`;
          });
        
          return [headers, ...rows].join('\n');
        },
    
        downloadCSV(csv, filename) {
          const blob = new Blob([csv], { type: 'text/csv' });
          const link = document.createElement('a');
    
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        
        downloadCreated() {
          const csv = this.arrayToCSV(this.createdResponseArray);
          this.downloadCSV(csv, 'created.csv');
        },
        downloadUpdated() {
          const csv = this.arrayToCSV(this.updatedResponseArray);
          this.downloadCSV(csv, 'updated.csv');
        },
        downloadFailed() {
          const csv = this.arrayToCSVFailed(this.failedResponseArray);
          this.downloadCSV(csv, 'failed.csv');
        }
    },
}


// WEBPACK FOOTER //
// ./src/views/components/uniware/newunicommerceproduct/newunicommerceproduct.component.js